/*
 * @Author: Merlin
 * @Date: 2024-03-11 14:16:26
 * @LastEditors: Merlin
 * @LastEditTime: 2024-03-11 14:16:57
 * @Description:
 */

import step01 from '../img/rules/rule_1.png';
import step02 from '../img/rules/rule_2.png';
import step03 from '../img/rules/rule_3.png';
import step04 from '../img/rules/rule_4.png';
import step05 from '../img/rules/rule_5.png';
import step06 from '../img/rules/rule_6.png';
// =======================================================
import MobileStep01 from '../img/rules/rule_1_mobile.png';
import MobileStep02 from '../img/rules/rule_2_mobile.png';
import MobileStep03 from '../img/rules/rule_3_mobile.png';
import MobileStep04 from '../img/rules/rule_4_mobile.png';
import MobileStep05 from '../img/rules/rule_5_mobile.png';
import MobileStep06 from '../img/rules/rule_6_mobile.png';


export const aBlackJackRule = [{
    content1: 'GameBlackJack.ruleDesc01',
    constent2: '',
    img: step01,
    imgMobile: MobileStep01,
}, {
    content1: 'GameBlackJack.ruleDesc02',
    constent2: '',
    img: step02,
    imgMobile: MobileStep02,
},{
    content1: 'GameBlackJack.ruleDesc03',
    constent2: '',
    img: step03,
    imgMobile: MobileStep03,
},{
    content1: 'GameBlackJack.ruleDesc04',
    constent2: '',
    img: step04,
    imgMobile: MobileStep04,
},{
    content1: 'GameBlackJack.ruleDesc05',
    constent2: '',
    img: step05,
    imgMobile: MobileStep05,
},{
    content1: 'GameBlackJack.ruleDesc06',
    constent2: '',
    img: step06,
    imgMobile: MobileStep06,
},];

